/**
 * Customizer
 * ======================================
 * - toggle class on tab nav item
 * - toggle hidden attribute on tabs
 * - html markup required (js-Customizer-select, js-Customizer-nav, js-Customizer-list)
 * - support for mobile select
 * - support multiple widgets
 */

const WIDGET = '.js-Customizer'
const ACTIVECLASS = 'current'

class Customizer {
  constructor() {
    this.elements = document.querySelectorAll(WIDGET)
    this.ajaxUrl = '/app/themes/ipress/ajax/index.php'

    this.elements.forEach((el) => {
      const nav = el.querySelectorAll('.js-Customizer-nav > *')
      const select = el.querySelector('.js-Customizer-select')
      const prev = el.querySelectorAll('.js-Customizer-prev')
      const next = el.querySelectorAll('.js-Customizer-next')
      const summary = el.querySelector('.js-Customizer-summary')
      const add_to_cart = el.querySelector('.js-Customizer-addToCart')

      el.addEventListener('change', this.changeFormHandler, false)

      document.addEventListener("DOMContentLoaded", function(){
        var event = new Event('change')
        el.dispatchEvent(event)
      })

      nav.forEach((el) => {
        el.addEventListener('click', this.clickHandler, false)
      })

      next.forEach((el) => {
        el.addEventListener('click', this.nextHandler, false)
      })

      prev.forEach((el) => {
        el.addEventListener('click', this.prevHandler, false)
      })

      summary.addEventListener('click', this.summaryHandler, false)
      add_to_cart.addEventListener('click', this.addToCartHandler, false)

      if(select){
        select.addEventListener('change', this.selectHandler, false)
      }
    })
  }

  summaryHandler = (e) => {
    const form = e.currentTarget.closest('form')

    this.summaryHandlerAjax(form)

    const lasttab = form.querySelector('.customizer__tab:last-child')

    this.switchTab(form, this.getIndex(lasttab))
  }

  addToCartHandler = (e) => {
    const form = e.currentTarget.closest('form')

    e.currentTarget.setAttribute('disabled', 'disabled')
    e.currentTarget.innerHTML = '<span>Saving...</span>'

    window.onbeforeunload = false

    this.addToCartHandlerAjax(form)

    e.preventDefault()
  }

  changeFormHandler = (e) => {
    const form = e.currentTarget.closest('form')

    window.onbeforeunload = function(e) {
      return 'Really?';
   };

    this.changeFormHandlerAjax(form)
  }

  addToCartHandlerAjax = form => {
		const formData = new FormData(form)
    formData.set("action", "customizer_add_to_cart")

		const xhr = new XMLHttpRequest()
		xhr.open('POST', this.ajaxUrl, true)
		xhr.send(formData)

		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {
				// ok
				if (xhr.status === 200) {
					const response = JSON.parse(xhr.response)

          window.location.href = response.redirect_url;
				}
				// error
				else {
					console.log('ajaxForm error!', xhr)
				}
			}
		}
	}

  summaryHandlerAjax = form => {
		const formData = new FormData(form)
    formData.set("action", "customizer_summary")

		const xhr = new XMLHttpRequest()
		xhr.open('POST', this.ajaxUrl, true)
		xhr.send(formData)

		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {
				// ok
				if (xhr.status === 200) {
					const response = JSON.parse(xhr.response)

          document.querySelector('#customizer-summary').innerHTML = response.html
				}
				// error
				else {
					console.log('ajaxForm error!', xhr)
				}
			}
		}
	}

  changeFormHandlerAjax = form => {
		const formData = new FormData(form)
    formData.set("action", "customizer_change_form")

		const xhr = new XMLHttpRequest()
		xhr.open('POST', this.ajaxUrl, true)
		xhr.send(formData)

		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {
				// ok
				if (xhr.status === 200) {
					const response = JSON.parse(xhr.response)
          document.querySelector('#customizer__price-number').innerHTML = response.totalPrice
				}
				// error
				else {
					console.log('ajaxForm error!', xhr)
				}
			}
		}
	}

  nextHandler = (e) => {
    const button = e.currentTarget
    const widget = button.closest(WIDGET)
    const tab = button.closest('.customizer__tab')

    this.switchTab(widget, this.getIndex(tab) + 1)

    setTimeout(() => {
      widget.closest('.customizer').scrollIntoView()
    }, 10);

    e.preventDefault()
  }

  prevHandler = (e) => {
    const button = e.currentTarget
    const widget = button.closest(WIDGET)
    const tab = button.closest('.customizer__tab')

    this.switchTab(widget, this.getIndex(tab) - 1)

    setTimeout(() => {
      widget.scrollIntoView()
    }, 10);

    e.preventDefault()
  }

  clickHandler = (e) => {
    const button = e.currentTarget
    const widget = button.closest(WIDGET)

    this.switchTab(widget, this.getIndex(button))
  }

  selectHandler = (e) => {
    const select = e.currentTarget
    const widget = select.closest(WIDGET)

    this.switchTab(widget, select.selectedIndex)
  }

  switchTab = (widget, index) => {
    const tabs = widget.querySelectorAll('.js-Customizer-list > *')
    const navs = widget.querySelectorAll('.js-Customizer-nav > *')

    this.reset(widget)

    tabs.forEach((tab) => {
      if (this.getIndex(tab) === index) {
        tab.removeAttribute('hidden')
      }
    })

    navs.forEach((nav) => {
      if (this.getIndex(nav) === index) {
        nav.classList.add(ACTIVECLASS)
      }
    })

    window.dispatchEvent(new CustomEvent('scroll'))
  }

  getIndex = (el) => {
    return [...el.parentNode.children].indexOf(el)
  }

  reset = (widget) => {
    const nav = widget.querySelectorAll('.js-Customizer-nav > *')
    const tabs = widget.querySelectorAll('.js-Customizer-list > *')

    nav.forEach((button) => {
      button.classList.remove(ACTIVECLASS)
    })

    tabs.forEach((tab) => {
      tab.setAttribute('hidden', 'hidden')
    })
  }
}

new Customizer()
